import { TimelineDot } from '@mui/lab';
import {
    PlayArrow as PlayArrowIcon, KeyboardArrowDown as KeyboardArrowDownIcon,
    Check as CheckIcon, SellOutlined as StatusIcon, AltRoute as AltRouteIcon,
    LockOpen as LockOpenIcon, CloudDownload as ChangeDataIcon, Badge as ChangeExtraIcon,
    NewReleases as ErrorIcon, KeyboardArrowRight as UnknownIcon, QuestionMark as QuestionMarkIcon,
    ArrowForward as ArrowForwardIcon, AccessAlarm as TimerIcon, SettingsOutlined as ExternalIcon,
    Refresh as RetryIcon
} from '@mui/icons-material';
import PackTypeIcon from '@components/pack/PackTypeIcon';

const ContactAuditDot = ({ audit }) => {
    let action = audit.action;
    if (action === 'external' && audit.details.error) {
        action = 'error';
    }
    switch (action) {

        case 'start':
            return (
                <TimelineDot color="primary">
                    <PlayArrowIcon />
                </TimelineDot>
            );

        case 'start_new_process':
            return (
                <TimelineDot variant="outlined" color="primary">
                    <AltRouteIcon color="primary" style={{ transform: 'scaleY(-1)' }} />
                </TimelineDot>
            );

        case 'release_lock':
            return (
                <TimelineDot color="warning">
                    <LockOpenIcon />
                </TimelineDot>
            );

        case 'finished':
            return (
                <TimelineDot color="success">
                    <CheckIcon />
                </TimelineDot>
            );

        case 'change_pointer':
            return (
                <TimelineDot variant="outlined" color="primary">
                    <KeyboardArrowDownIcon color="primary" />
                </TimelineDot>
            );

        case 'change_data':
            return (
                <TimelineDot variant="outlined" color="primary">
                    <ChangeDataIcon color="primary" />
                </TimelineDot>
            );

        case 'change_status':
            return (
                <TimelineDot color="primary">
                    <StatusIcon />
                </TimelineDot>
            );

        case 'change_extra':
            return (
                <TimelineDot variant="outlined" color="primary">
                    <ChangeExtraIcon color="primary" />
                </TimelineDot>
            );

        case 'send_mail':
            return (
                <TimelineDot color="primary">
                    <PackTypeIcon type="email" />
                </TimelineDot>
            );

        case 'send_sms':
            return (
                <TimelineDot color="primary">
                    <PackTypeIcon type="sms" />
                </TimelineDot>
            );

        case 'waiting_for_action':
            return (
                <TimelineDot color="primary">
                    <QuestionMarkIcon />
                </TimelineDot>
            );

        case 'waiting_for_retry':
            return (
                <TimelineDot color="primary">
                    <RetryIcon />
                </TimelineDot>
            );

        case 'action_received':
            return (
                <TimelineDot color="primary">
                    <ArrowForwardIcon />
                </TimelineDot>
            );

        case 'default_flow':
            return (
                <TimelineDot color="primary">
                    <TimerIcon />
                </TimelineDot>
            );

        case 'external':
            return (
                <TimelineDot color="primary">
                    <ExternalIcon />
                </TimelineDot>
            );

        case 'error':
            return (
                <TimelineDot color="error">
                    <ErrorIcon />
                </TimelineDot>
            );

        default:
            return (
                <TimelineDot color="primary">
                    <UnknownIcon />
                </TimelineDot>
            );

    }
};

export default ContactAuditDot;